import React, { useEffect, useState } from "react";
import LogStatusBar from "../features/log-status-bar/LogStatusBar";
import CameraView from "../features/camera-preview/CameraView";
import Toast from "../components/Toast.js";

const MainView = ({
  toastMessages,
  socket,
  alertLength,
  diskdata,
  cameraStatusMessage,
  lidarStatus
}) => {
  const [diskIsConnected, setDiskIsConnected] = useState();
  const [isRunning, setIsRunning] = useState(true);
  const [warningMessages, setWarningMessages] = useState([]);
  const [usedDiskSpace, setUsedDiskSpace] = useState(null);
  const [statusText, setStatusText] = useState("Not Ready");
  const [lastUpdated, setLastUpdated] = useState(0);
  const [cameraData, setCameraData] = useState([]);

  useEffect(() => {
    const cameraListener = (images) => {
      if (cameraStatusMessage.length === 0) return;
      let cameraAmount = (cameraStatusMessage.length - 1)
      let camera = {
        name: images.name,
        image: `data:image/jpeg;base64,${images.image}`,

        status: (cameraStatusMessage[cameraAmount][images.name]) ? cameraStatusMessage[cameraAmount][images.name]["status"] : false
      };

      setCameraData((prevState) => {
        const res = prevState.some(allreadyExist);

        function allreadyExist(item) {
          return item.name === images.name;
        }

        if (res === false) {
          return prevState.concat(camera);
        }

        if (res === true) {
          return prevState.map((value) =>
            value.name === camera.name ? camera : value
          );
        }
      });
    };

    if (socket === null) return;
    socket.on("CAMERA_IMAGE", cameraListener);

    return () => {
      socket.off("CAMERA_IMAGE", cameraListener);
    };
  }, [socket, cameraStatusMessage]);

  useEffect(() => {
    let intervalId = setInterval(() => {
      setLastUpdated((prev) => (prev += 1));
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const addToAlertWarningMessageList = warningMessages.some((item) => {
      if (item.name === "not-receiving-system-information") {
        return true;
      }

      return false;
    });

    if (lastUpdated > 30) {
      if (!addToAlertWarningMessageList) {
        setWarningMessages((prevState) => [
          ...prevState,
          {
            name: "not-receiving-system-information",
            icon: "warning",
            message: `Not receiving system information`,
          },
        ]);
      }
    } else {
      if (addToAlertWarningMessageList) {
        setWarningMessages((prevState) => [
          ...prevState.filter(
            (msg) => msg.name !== "not-receiving-system-information"
          ),
        ]);
      }
    }
  }, [lastUpdated, warningMessages]);

  useEffect(() => {
    if (diskdata) {
      let isDiskConnected = diskdata.writable;
      setDiskIsConnected(isDiskConnected);

      if (diskIsConnected === false) {
        setIsRunning(false);
        setStatusText("Not Ready")
      }

      if (diskIsConnected === true) {
        setIsRunning(true);
        let usedDiskSpaceInMB =
          diskdata.total_disk_space_MB - diskdata.free_disk_space_MB;
        let calculatePercentage =
          (usedDiskSpaceInMB / diskdata.total_disk_space_MB) * 100;
        let diskSpaceInPercentWithNoDeceimals = Math.trunc(calculatePercentage);
        setUsedDiskSpace(diskSpaceInPercentWithNoDeceimals);

        if (usedDiskSpace < 95) {
          setStatusText("Ready");
        }
      }
      // if (alertLength > 0) {
      //   setStatusText("Not Ready");
      // }
    }
  }, [diskdata, alertLength, diskIsConnected, usedDiskSpace]);

  return (
    <>
      <main className="flex flex-col w-full h-screen">
        {toastMessages.length === 0 ? null : <Toast messages={toastMessages} />}
        <section className="h-full">
          <CameraView
            cameradata={cameraData}
            disk={usedDiskSpace}
            isdiskconnected={diskIsConnected}
          />
        </section>
        <section className="h-[180px]">
          <LogStatusBar
            socket={socket}
            status={statusText}
            disk={usedDiskSpace}
            isConnected={isRunning}
            lidarStatus={lidarStatus}
          />
        </section>
      </main>
    </>
  );
};

export default MainView;
